<script lang="ts">
	import Icon from '$lib/elements/Icon.svelte';
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';
	import type { KYCIntroduction, UnansweredQuestions } from '@app/models/api/KYCModel';

	import { beforeUpdate } from 'svelte';
	import { t } from 'svelte-i18n';
	import { KYCUnansweredQuestion } from '@app/stores/KYCUnansweredQuestion';
	import { KYCMissingDocument } from '@app/stores/KYCMissingDocument';
	import type { Writable } from 'svelte/store';
	import { KYCCategoriesName } from '@app/enums/KYC';

	export let introduction: KYCIntroduction;
	export let currentQuestionIndex;
	export let currentStepIndex;

	let unansweredQuestion: Writable<UnansweredQuestions> | null;
	let missingDocument: Writable<any> | null;

	beforeUpdate(() => {
		unansweredQuestion = KYCUnansweredQuestion;
		missingDocument = KYCMissingDocument;

		if (
			$unansweredQuestion?.categorie?.name == KYCCategoriesName.Finish &&
			$missingDocument.length &&
			introduction.id === 3
		) {
			currentStepIndex = $missingDocument[0]?.categorie?.step;
			currentQuestionIndex = $missingDocument[0]?.question?.index;
		}
	});
</script>

<div class={`md:pl-7 text-start text-lg`}>
	{#if introduction.subTitle}
		<p class="text-primary font-bold">
			{introduction?.subTitle}
		</p>
	{/if}
	{#if introduction?.title}
		<h2 class="text-[32px]">
			{@html introduction?.title}
		</h2>
		<div class="border border-primary border-2 w-[75%]" />
	{/if}
	<div class="my-5">
		{#if introduction?.itemsList}
			{@html introduction?.itemsList}
		{/if}
		{#if introduction?.text}
			<p>{@html introduction.text}</p>
		{/if}
	</div>
	<ButtonBoxPrimary
		on:click={() => {
			if (introduction?.buttonAction) {
				introduction.buttonAction();
			} else {
				introduction.isVisible = false;
			}
		}}
		props={{
			label: introduction?.buttonLabel ?? $t('kyc.startedButtonText'),
			size: 'huge',
			classNames: 'py-4'
		}}
	/>
	{#if introduction?.questionMark}
		<div class="flex my-5">
			<Icon name={'question-mark'} classNames="mr-2 text-primary" />
			{@html introduction?.questionMark}
		</div>
	{/if}
</div>
